import { useContext } from 'react';
import { ILoadingContext, LoadingContext } from '../../providers/LoadingContext';

export default function useLoading(): ILoadingContext {
  return useContext(LoadingContext);
}
